export const dataStartedAt = {
  type: 'number',
};
